import * as ExcelJS from 'exceljs';
import { LocLabelModifier } from '../components/clickable-row-table/models/data-table-config.models';
import { ExcelFileFactory } from '../factories/excel-file.factory';

export const width = ExcelFileFactory.pxToExcelWidth;
export const sort = true;
export const CAP = LocLabelModifier.CAP;

// defaults:
export const style: Partial<ExcelJS.Style> = {
  alignment: { horizontal: 'left', vertical: 'middle', wrapText: true },
  font: { name: 'Calibri', size: 10, color: { argb: undefined } }
};
export const filterButton = true;
export const hidden = true;

// styles styles
export const percent: Partial<ExcelJS.Style> = { ...style, numFmt: '0.00%' };
export const fixed: Partial<ExcelJS.Style> = { ...style, numFmt: '0.00' };
export const dateTime: Partial<ExcelJS.Style> = { ...style, numFmt: 'dd.mm.rrrr gg:mm' };
export const note: Partial<ExcelJS.Style> = {
  ...style,
  alignment: { horizontal: 'left', vertical: 'middle', wrapText: true }
};
